import {useState, useEffect,useMemo} from 'react';
import Select from 'react-select';

const SelectServicioSoftland = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps,
    isMulti
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const [options, setOptions] = useState([
        {
            value: 'PLAN S',
            label: 'PLAN S'
        },
        {
            value: 'PLAN M',
            label: 'PLAN M'
        },
        {
            value: 'PLAN L',
            label: 'PLAN L'
        },
        {
            value: 'PLAN XL',
            label: 'PLAN XL'
        },
        {
            value: 'PLAN PLATA',
            label: 'PLAN PLATA'
        },
        {
            value: 'PLAN ORO',
            label: 'PLAN ORO'
        },
        {
            value: 'PLAN PLATINUM',
            label: 'PLAN PLATINUM'
        },
        {
            value: 'PLAN CORPORTATIVO',
            label: 'PLAN CORPORTATIVO'
        },
        {
            value: 'PLAN GOBIERNO',
            label: 'PLAN GOBIERNO'
        },
        {
            value: 'PLAN 200 Mb',
            label: 'PLAN 200 Mb'
        },
        {
            value: 'PLAN 400 Mb',
            label: 'PLAN 400 Mb'
        },
        {
            value: 'PLAN 700 Mb',
            label: 'PLAN 700 Mb'
        },
        {
            value: 'PLAN 1000 Mb',
            label: 'PLAN 1000 Mb'
        },
        {
            value: 'PLAN BASIC 100 Mb',
            label: 'PLAN BASIC 100 Mb'
        },
        {
            value: 'PLAN PLUS 300 Mb',
            label: 'PLAN PLUS 300 Mb'
        },
        {
            value: 'PLAN LIFE 600 Mb',
            label: 'PLAN LIFE 600 Mb'
        },
        {
            value: 'PLAN FO 600/300 MB',
            label: 'PLAN FO 600/300 Mb'
        },
        {
            value: 'IPTV',
            label: 'IPTV'
        },
        {
            value: 'CAMBIO DE PLAN',
            label: 'CAMBIO DE PLAN'
        },
        {
            value: 'CAMBIO DE DOMICILIO',
            label: 'CAMBIO DE DOMICILIO'
        },
        {
            value: 'OTROS',
            label: 'OTROS'
        }
    ]);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        if(typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }
    }, [options,value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectServicioSoftland.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectServicioSoftland;